/**
 * Module-level monotone counter zodat IDs binnen één tab uniek zijn,
 * gecombineerd met Date.now() voor cross-tab/refresh-uniqueness.
 *
 * Gebruikt voor pendingMessage.localId en AttachedFile.id — beide UI-only,
 * niet zichtbaar voor de server. Server-side IDs komen separaat binnen.
 */
let counter = 0;

export function makeLocalId(): string {
  counter += 1;
  return `local-${Date.now()}-${counter}`;
}
